import state from './moduleAddressState.js'
import actions from "./moduleAddressActions";
import mutations from './moduleAddressMutations.js'



export default {
    isRegistered: false,
    namespaced: true,
    mutations: mutations,
    state: state,
    actions: actions,
}
